import bilAPI from '../api';

export const getAnswers = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/question_answers/', {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
